import { useEffect } from "react";
import { useNavigate } from "@/router";
import useEffectiveDisplayUser from "@/hooks/useEffectiveDisplayUser";
import TasksTabContent from "../../_components/TasksTabContent";

export default function DepartmentTasksPage() {
  const navigate = useNavigate();
  const user = useEffectiveDisplayUser();
  const userDepartment = user?.department;

  useEffect(() => {
    if (user && !userDepartment) {
      navigate("/tasks/my-tasks", { replace: true });
    }
  }, [user, userDepartment, navigate]);

  if (!userDepartment) {
    return null;
  }

  return (
    <TasksTabContent
      source="department_tasks_tab"
      queryOptions={{ fixedDepartment: userDepartment, useTeamTagForDepartment: true, showUnassignedChip: true }}
    />
  );
}
